import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

import { OneOnOneAgendaNotesI } from '../../Agenda/hooks/dataHooks';

export const getOneOnOneInstanceNotesApi = ({
  masterId,
  instanceId,
  isPrivate = false,
}: {
  masterId: number;
  instanceId?: number;
  isPrivate: boolean;
}) => {
  const url = endpoints.oneOnOneRevamped.notes(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
      isPrivate,
    },
  });
};

export const updateOneOnOneInstanceNotesApi = ({
  masterId,
  instanceId,
  isPrivate = false,
  ...rest
}: {
  masterId: number;
  instanceId?: number;
  isPrivate: boolean;
} & OneOnOneAgendaNotesI) => {
  const url = endpoints.oneOnOneRevamped.notes(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
    body: {
      isPrivate,
      ...rest,
    },
  });
};
